// extracted by mini-css-extract-plugin
export default {"wrapper":"CheckBox_wrapper__kLJy8","input":"CheckBox_input__RXuJ5","box":"CheckBox_box__Td98U"};